/**
 * Enum of widget separation modes
 */
export const SAME_WIDGET_FOR_ALL = "sameWidgetForAll"
export const SEPARATE_WIDGET_BY_VISITOR_PROFILE =
  "separateWidgetsByVisitorProfile"

/**
 * Object of all widget separation modes
 */
export const WIDGET_SEPARATION_MODES = {
  SAME_WIDGET_FOR_ALL,
  SEPARATE_WIDGET_BY_VISITOR_PROFILE
}
